import { PostFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";

// The Cases list's own calls (the case screen keeps api.js). The page says
// a failure itself, inline with Try again, so none of these toast.
const quiet = (route, data, dispatch) => PostFunction({ Route: route, data, isMultipart: false, showalert: false, showerror: false, dispatch });

export const listApi = {
  list: (body, dispatch) => quiet(UrlApi.cases.list, body, dispatch),
  // Every case under the filters (up to 2,000), for the CSV export.
  exportAll: (body, dispatch) => quiet(UrlApi.cases.list, { ...body, page: 0, rowsPerPage: 100, export: true }, dispatch),
  agents: (dispatch) => quiet(UrlApi.cases.agents, {}, dispatch),
  // One agent's day (API caseList.js / myDay.js).
  myDay: (hideTest, dispatch) => quiet("cases/my-day", { hide_test: !!hideTest }, dispatch),
  // "Take the next case" (round 2): the first case nobody owns becomes mine.
  // id: the case My day named, so only that one is taken (409 when it has
  // gone); notify: false takes it without emailing the customer (nadia-03).
  takeNext: (hideTest, dispatch, { id, notify } = {}) =>
    quiet("cases/take-next", { hide_test: !!hideTest, ...(id ? { id: Number(id) } : {}), ...(notify === false ? { notify: false } : {}) }, dispatch),
  // The team's due numbers for Home: one row is enough, the stats count every open case.
  dueStats: (hideTest, dispatch) => quiet(UrlApi.cases.list, { view: "needs_action", page: 0, rowsPerPage: 1, hide_test: !!hideTest }, dispatch),
};
